module.exports = __webpack_public_path__ + "img/avatar-woman.c921883a.svg";